import { MarketplaceAnalyticsContext } from '@atlassian/mpac-analytics';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { NotFound } from '@atlassian/mpac-primitives';
import { useParams } from '@atlassian/mpac-ui';
import React from 'react';
import { lazyForPaint, LazySuspense } from 'react-loosely-lazy';

import BaseRouteHandler from '../../Routes/components/common/routeHandlers/BaseRouteHandler';
import { FEDRAMP_PAGE_URL_SLUG, ISOLATED_CLOUD_PAGE_URL_SLUG } from './constants';
import { Analytics } from './constants/analytics';

const CollectionPageCodeSplit = lazyForPaint(() =>
  import(
    /* webpackPrefetch: true, webpackChunkName: "chunk-collectionPage" */ './CollectionPage'
  ).then((module) => module.default)
);

const RouteHandler = () => {
  const { slug } = useParams();
  const { enableRunsOnAtlassian, enableFedrampChanges, enableIsolatedCloudChanges } = useStatsig();

  // Check if runs-on-atlassian collection should be hidden
  const hideRunsOnAtlassianPage = slug === 'runs-on-atlassian' && !enableRunsOnAtlassian();
  const hideIsolatedCloudPage =
    slug === ISOLATED_CLOUD_PAGE_URL_SLUG && !enableIsolatedCloudChanges();
  const hideFedRampPage = slug === FEDRAMP_PAGE_URL_SLUG && !enableFedrampChanges();

  if (hideRunsOnAtlassianPage || hideIsolatedCloudPage || hideFedRampPage) {
    return <NotFound />;
  }

  // TODO: MC-4631 - Handle suspense fallback
  return (
    <BaseRouteHandler scrollToTopOnPathChange includePartnerQuickLinks>
      <MarketplaceAnalyticsContext properties={{ source: Analytics.source }}>
        <LazySuspense fallback={<div />}>
          <CollectionPageCodeSplit />
        </LazySuspense>
      </MarketplaceAnalyticsContext>
    </BaseRouteHandler>
  );
};

export default RouteHandler;
